import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.1797 3.27246H4.82099C3.06237 3.27246 1.63672 4.52913 1.63672 6.07931V12.3947C1.63672 13.9449 3.06237 15.2016 4.82099 15.2016H13.1797C14.9383 15.2016 16.364 13.9449 16.364 12.3947V6.07931C16.364 4.52913 14.9383 3.27246 13.1797 3.27246Z",
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.68164 6.14258L7.41732 9.04065C7.89786 9.28677 8.44373 9.41642 8.9995 9.41642C9.55528 9.41642 10.1012 9.28677 10.5817 9.04065L16.3333 6.14258",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEmail;
